import { render, staticRenderFns } from "./SitesListTable.vue?vue&type=template&id=127043c2&"
import script from "./SitesListTable.vue?vue&type=script&lang=ts&"
export * from "./SitesListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports